import {SplitPageLayout} from '@primer/react'
import {Diffs} from '../components/Commit/Diffs'
import {FileTree} from '../components/Commit/FileTree'
import {updateURLHash} from '@github-ui/diff-lines/document-hash-helpers'
import {CommitInfo} from '../components/Commit/CommitInfo'
import {useCallback, useState} from 'react'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {CommitPayload} from '../types/commit-types'
import {SelectedDiffRowRangeContextProvider} from '@github-ui/diff-lines'
import type {DiffDelta} from '@github-ui/diff-file-tree'
import {DiffViewSettingsProvider} from '../contexts/DiffViewSettingsContext'
import {CommitComments} from '../components/Commit/CommitComments'

export function Commit() {
  const payload = useRoutePayload<CommitPayload>()
  const treeEnabled = payload.files.length > 1

  const [treeExpanded, setTreeExpanded] = useState(treeEnabled)
  const handleFileSelected = useCallback((file: DiffDelta) => {
    updateURLHash(file.pathDigest)
    // TODO PRX uses a context for tracking and scrolling to selected file, extract and re-use?
    // setFocusedFileDigest(file.pathDigest)
  }, [])
  return (
    <SelectedDiffRowRangeContextProvider>
      <SplitPageLayout>
        <SplitPageLayout.Header>
          <CommitInfo commit={payload.commit} />
        </SplitPageLayout.Header>
        <SplitPageLayout.Pane hidden={!treeExpanded}>
          <FileTree diffs={payload.files} onFileSelected={handleFileSelected} />
        </SplitPageLayout.Pane>
        <SplitPageLayout.Content as="div">
          <DiffViewSettingsProvider
            viewSettings={{
              hideWhitespace: false,
              splitPreference: payload.splitViewPreference,
            }}
          >
            <Diffs
              setTreeExpanded={setTreeExpanded}
              treeExpanded={treeExpanded}
              treeEnabled={treeEnabled}
              diffEntryData={payload.diffEntryData}
              contextLinePathURL={payload.contextLinePathURL}
            />
            <CommitComments initialComments={payload.comments} commit={payload.commit} />
          </DiffViewSettingsProvider>
        </SplitPageLayout.Content>
      </SplitPageLayout>
    </SelectedDiffRowRangeContextProvider>
  )
}

try{ Commit.displayName ||= 'Commit' } catch {}